import React, { Component } from 'react';
import {
	Image,
	Modal
} from 'react-bootstrap';

import Employee from '../Employee/Employee';
import RequestForm from '../Request/RequestForm';
import loading from '../../loading.svg';
import { editRequest } from '../../utils/editRequests';

export default class Profile extends Component {
	constructor(props) {
		super(props);

		this.state = {
			profile: {},
			showForm: false,
			requests: []
		}

		this.addRequest = this.addRequest.bind(this);
		this.editRequest = this.editRequest.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
	}

	componentDidMount() {
		const { userProfile, getProfile } = this.props.auth;

		if (!userProfile) {
			getProfile((err, profile) => {
				this.setState({ profile });
			});
		} else {
			this.setState({ profile: userProfile });
		}
	}

	handleOpen() {
		this.setState({ showForm: true });
	}

	handleClose() {
		this.setState({ showForm: false });
	}

	addRequest(request) {
		const { requests } = this.state;

		const allRequests = requests.concat(request);

		this.setState({ requests: allRequests });
	}

	editRequest(id, approved) {
		const { requests } = this.state;
		const requestToEdit = requests.find(request => request.id === id);
		const requestIndex = requests.indexOf(requestToEdit);

		editRequest(id, approved)
			.then(resp => {
				requestToEdit.fields["approved?"] = approved;
				requests[requestIndex] = requestToEdit;

				this.setState({ requests });
			});
	}

	render() {
		const { profile, requests, showForm } = this.state;
		const ptoId = profile["http://noeltrans.com/ptoId"];

		if (ptoId) {
			return <div>
				<Image style={{height: 170, margin: "0 auto", display: "block"}} src={profile.picture} thumbnail />
				<Employee employeeId={ptoId} handleOpen={this.handleOpen} requests={requests} addRequest={this.addRequest} editRequest={this.editRequest} />
				<Modal show={showForm} onHide={this.handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>Paid Time Off Request</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<RequestForm employeeId={ptoId} closeForm={this.handleClose} addRequest={this.addRequest} />
					</Modal.Body>
				</Modal>
			</div>
		}

		return <div><img src={loading} alt="Loading" /></div>
	}
}


// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js